<template>
  <div class="pb-32 md:pb-0">
    <!-- <notification-params /> -->
    <ontick-container v-show="Object.keys(info).length > 0" :hasPadding="true">
      <!-- Header -->
      <edit-header></edit-header>
      <!-- /Header -->
      <div class="col-span-full grid w-full grid-cols-1 gap-4 lg:grid-cols-4">
        <!-- Sections -->
        <edit-section class="col-span-full lg:col-span-1"></edit-section>
        <!-- /Sections -->

        <!-- Content -->
        <edit-content class="col-span-full md:col-span-3"></edit-content>
      </div>
      <!-- /Content -->
    </ontick-container>
    <!-- <Loading v-if="Object.keys(info).length == 0" /> -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "edit-params",
  components: {
    NotificationParams: () =>
      import("../../components/edit/notification-params.component"),
    EditHeader: () => import("../../components/edit/edit-header.component"),
    EditSection: () => import("../../components/edit/edit-section.component"),
    EditContent: () => import("../../components/edit/edit-content.component"),
    Loading: () =>
      import("@/app/shared/components/loading/loading.page.component.vue"),
  },
  computed: {
    ...mapGetters({ info: "investment/getParametersInfo" }),
  },
  methods: {
    ...mapActions({ setSaveIsEnabled: "investment/setSaveIsEnabled" }),
  },
  unmounted() {
    this.setSaveIsEnabled(true);
  },
};
</script>

<style lang="scss">
@import "./edit.component.scss";
</style>
